import { logWorkspace, requireUser, updateUserStatus } from '../..';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import { userStatsFromAgentStats } from '../../types/ServiceUser';
import appManager from '@app/appManager';
import {
  ServiceSessionEventType,
  ServiceSessionUserEvent,
} from '../../types/ServiceEvents';

/**
 * The rescind event indicates that an offer has been rescinded from
 * the recipient. This could happen for example if a session hung-up
 * while it was being offered.
 * @param event
 */
async function handleAgentSessionRescinded(
  event: Telecom.AgentSessionRescindedEvent,
) {
  const user = await requireUser(event.agentId);
  logWorkspace('service:agent:session_rescinded:' + user?.name, event);

  user.availabilityState = '';
  user.stats = userStatsFromAgentStats(event.stats);

  // update our status. status can be changed again
  updateUserStatus(user.id, undefined, true);

  if (event.conversationId) {
    appManager.events.emit<ServiceSessionUserEvent>(
      ServiceSessionEventType.RESCINDED,
      {
        sessionId: event.conversationId,
        sessionSid: '--tbd--',
        agentId: event.agentId,
        userId: user.id,
      },
    );
  }
}

export default handleAgentSessionRescinded;
